import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Chip,
  Stack,
  Tabs,
  Tab,
  TextField, // جديد: شريط البحث
  InputAdornment, // لعرض أيقونة داخل الحقل
  FormControl, // جديد: حاوية الـ Select
  InputLabel, // جديد: تسمية الـ Select
  Select, // جديد: فلتر الحالة
  MenuItem, // جديد: خيارات الفلتر
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getRenews } from "../../../Services/RenewTanentPlaneApi";
import { getPlane } from "../../../Services/plansApi"; // أضفنا جلب الباقات
import RenewSystemDialog from "./RenewSystemDialog"; // جديد: حوار إنشاء التجديد
import AllSubscriptionsReportsTap from "./AllSubscriptionsReportsTap"; // تاب التقارير (تأكد من وجود المكوّن)
import SearchIcon from "@mui/icons-material/Search"; // جديد
import ClearIcon from "@mui/icons-material/Clear"; // جديد

const AllSubscriptionsPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (e, nv) => setTabIndex(nv);

  const [renews, setRenews] = useState([]);
  const [groupedRenews, setGroupedRenews] = useState([]); // مجموعات حسب tenant_id
  const [selectedGroup, setSelectedGroup] = useState(null); // مجموعة مختارة للحوار
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState(null);

  // حالة لحوار إنشاء التجديد وتمرير القيم الافتراضية
  const [openRenewDialog, setOpenRenewDialog] = useState(false);
  const [renewDefaults, setRenewDefaults] = useState(null);
  // toggle لإعادة جلب البيانات بعد نجاح الإنشاء
  const [refreshToggle, setRefreshToggle] = useState(false);

  // الحالة التي ستستقبل بيانات التجديد التي أرسلها الـ dialog بعد النجاح
  const [lastRenewInfo, setLastRenewInfo] = useState(null);

  // نص البحث الحر
  const [searchTerm, setSearchTerm] = useState("");
  // debounce بسيط
  const [debouncedSearch, setDebouncedSearch] = useState("");
  // فلتر حالة النسخة: 'all' | 'active' | 'inactive'
  const [statusFilter, setStatusFilter] = useState("all");

  // فلتر الموظف وقائمة الأسماء المتاحة
  const [employeeFilter, setEmployeeFilter] = useState("all");
  const [employeesList, setEmployeesList] = useState([]);

  // فلتر الباقة وقائمة الباقات المتاحة
  const [planFilter, setPlanFilter] = useState("all");
  const [plansList, setPlansList] = useState([]);

  // فلتر نطاق التاريخ (بداية - نهاية)
  const [dateFrom, setDateFrom] = useState(""); // شكل: "YYYY-MM-DD"
  const [dateTo, setDateTo] = useState("");

  // فلتر نطاق تاريخ التجديد (من - إلى)
  const [renewDateFrom, setRenewDateFrom] = useState("");
  const [renewDateTo, setRenewDateTo] = useState("");

  useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      try {
        setLoading(true);
        setError("");
        // نجلب الباقات وسجلات التجديد بالتوازي
        const [plansRes, renewsRes] = await Promise.all([getPlane(), getRenews()]);

        // بناء خريطة الباقات id -> planObject
        const plansArray = plansRes?.data?.data?.palnes || plansRes?.data?.palnes || [];
        const plansMap = {};
        Array.isArray(plansArray) && plansArray.forEach((p) => {
          if (p && p.id !== undefined) plansMap[String(p.id)] = p;
        });

        // استخراج مصفوفة التجديدات من الاستجابة
        const rawRenews = renewsRes?.data?.data ?? (Array.isArray(renewsRes?.data) ? renewsRes.data : []);
        // ضم اسم الباقة والأسعار لكل سجل
        const mapped = (Array.isArray(rawRenews) ? rawRenews : []).map((r) => {
          const planeId = r?.tenant?.plane_id;
          const planObj = plansMap[String(planeId)];
          return {
            ...r,
            plan_name: planObj?.plane_name ?? "غير محدد",
            plan_monthly: planObj?.monthly_price ?? null,
            plan_yearly: planObj?.yearly_price ?? null,
            plan_price: planObj?.price ?? null,
          };
        });

        if (mounted) {
          setRenews(mapped);

          // تجميع حسب tenant.id أو tenant_id
          const groups = {};
          mapped.forEach((r) => {
            const key = r?.tenant?.id ?? r?.tenant_id ?? "unknown";
            if (!groups[key]) {
              groups[key] = {
                tenant_id: r?.tenant?.id ?? r?.tenant_id ?? key,
                tenant: r.tenant || {},
                plan_name: r.plan_name,
                plan_monthly: r.plan_monthly,
                entries: [],
                total_cost: 0,
                count: 0,
                last_renew_date: null,
                latestEntry: null,
              };
            }
            groups[key].entries.push(r);
            const cost = parseFloat(r.cost) || 0;
            groups[key].total_cost += cost;
            groups[key].count += 1;
            const created = r.created_at || r.renew_date || null;
            if (!groups[key].last_renew_date || new Date(created) > new Date(groups[key].last_renew_date)) {
              groups[key].last_renew_date = created;
              groups[key].latestEntry = r;
            }
          });

          // احسب end_date لكل مجموعة (من tenant أو من أول سجل)
          Object.keys(groups).forEach((k) => {
            const g = groups[k];
            g.end_date = g.tenant?.end_date ?? g.entries[0]?.tenant?.end_date ?? null;
          });

          // دالة مساعدة لحساب الفرق بالأيام (قد تكون سالبة إذا انتهت)
          const diffDays = (dateStr) => {
            if (!dateStr) return Number.POSITIVE_INFINITY;
            try {
              const end = new Date(dateStr);
              const now = new Date();
              const utc1 = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
              const utc2 = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
              return Math.ceil((utc2 - utc1) / (1000 * 60 * 60 * 24));
            } catch {
              return Number.POSITIVE_INFINITY;
            }
          };

          // رتب المجموعات حسب قرب تاريخ الانتهاء (الأقل أولاً؛ القيم السالبة تظهر أولاً)
          const sorted = Object.values(groups).sort((a, b) => {
            return diffDays(a.end_date) - diffDays(b.end_date);
          });

          setGroupedRenews(sorted);
          // بعد تعيين المجموعات سنقوم باستخراج أسماء الموظفين الفريدة (إن وجدت)
          const names = new Set();
          sorted.forEach((g) => {
            (g.entries || []).forEach((e) => {
              const name = (e.employee_name || e.employee || "").toString().trim();
              if (name) names.add(name);
            });
          });
          setEmployeesList(Array.from(names).sort((a, b) => a.localeCompare(b)));
          // استخراج قائمة الباقات الفريدة من المجموعات والإدخالات
          const plans = new Set();
          sorted.forEach((g) => {
            if (g.plan_name) plans.add(g.plan_name.toString());
            (g.entries || []).forEach((e) => {
              if (e.plan_name) plans.add(e.plan_name.toString());
            });
          });
          setPlansList(Array.from(plans).sort((a, b) => a.localeCompare(b)));
        }
      } catch (err) {
        console.error("getRenews error:", err);
        if (mounted) setError(err?.response?.data?.message || err.message || "حدث خطأ أثناء جلب البيانات");
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetch();
    return () => {
      mounted = false;
    };
  }, [refreshToggle]); // إعادة الجلب عند تبديل refreshToggle

  // Debounce لنص البحث لتقليل الفلترة أثناء الكتابة
  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
    }, 300);
    return () => clearTimeout(t);
  }, [searchTerm]);

  // افتح حوار التجديد مع القيم الافتراضية من المجموعة g
  const handleOpenRenew = (g) => {
    const tenantId = g.tenant_id;
    const first = g.entries[0] || {};
    const cost = first.cost ?? "";
    const start_date = first.tenant?.start_date ?? first.start_date ?? "";
    const end_date = first.tenant?.end_date ?? first.end_date ?? "";
    setRenewDefaults({ tenant_id: tenantId, cost, start_date, end_date });
    setOpenRenewDialog(true);
  };

  // عند نجاح الإنشاء: اغلق الحوار وأعد تحميل البيانات
  // الآن تتلقى (res, payload) حيث payload يحتوي cost, start_date, end_date, tenant_id, ...
  const handleRenewSuccess = (res, payload) => {
    setOpenRenewDialog(false);
    setRenewDefaults(null);
    // خزّن القيم المستلمة لتستعملها هنا لاحقًا (أو تعرضها)
    setLastRenewInfo(payload || null);
    setRefreshToggle((v) => !v);
  };

  // helper: ترجمة حالة المستأجر إلى نص ولون
  const tenantStatusText = (status) => (status === 1 ? "نشط" : "غير نشط");
  const tenantStatusColor = (status) => (status === 1 ? "success" : "error");

  // مساعد لتهيئة التاريخ بصيغة عربية قصيرة مع وقت بنظام 12 ساعة
  const formatDate = (d) => {
    if (!d) return "-";
    try {
      const dt = new Date(d);
      const datePart = dt.toLocaleDateString("ar-EG");
      const timePart = dt.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
      return `${datePart} ${timePart}`;
    } catch {
      return d;
    }
  };

  // احسب عدد الأيام المتبقية حتى تاريخ الانتهاء (endDate) -> عدد صحيح (يمكن أن يكون سالباً)
  const daysRemaining = (endDate) => {
    if (!endDate) return null;
    try {
      const end = new Date(endDate);
      // نشتغل على الفرق بين تواريخ بدون وقت
      const now = new Date();
      const utc1 = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
      const utc2 = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
      return Math.ceil((utc2 - utc1) / (1000 * 60 * 60 * 24));
    } catch {
      return null;
    }
  };

  const renderDaysChip = (days) => {
    if (days === null) return <Typography variant="body2" sx={{ color: "text.secondary" }}>-</Typography>;
    if (days < 0) return <Chip label={`انتهت`} color="error" size="small" />;
    if (days <= 7) return <Chip label={`${days} يوم`} color="warning" size="small" />;
    return <Chip label={`${days} يوم`} color="success" size="small" />;
  };

  // دالة تحقق ما إذا كانت المجموعة تتطابق مع نص البحث
  const groupMatchesSearch = (g, term) => {
    if (!term) return true;
    const t = term.toLowerCase();
    const parts = [];
    parts.push(String(g.tenant_id ?? ""));
    parts.push(String(g.plan_name ?? ""));
    parts.push(String(g.plan_monthly ?? ""));
    // أول سجل كمصدر للمعلومات السريعة
    const first = g.entries?.[0] ?? {};
    parts.push(String(first.user?.name ?? ""));
    parts.push(String(first.user?.email ?? ""));
    parts.push(String(first.user?.phone ?? ""));
    // وسيط
    const broker = first.user?.broker;
    if (broker) {
      parts.push(typeof broker === "string" ? broker : String(broker.name ?? ""));
      parts.push(String(broker.code ?? ""));
      parts.push(String(broker.email ?? ""));
    }
    // ابحث داخل كل الإدخالات (ملاحظات، موظف، سعر، اسم الباقة)
    (g.entries || []).forEach((e) => {
      parts.push(String(e.notes ?? ""));
      parts.push(String(e.employee_name ?? ""));
      parts.push(String(e.cost ?? ""));
      parts.push(String(e.plan_name ?? ""));
    });
    return parts.join(" ").toLowerCase().includes(t);
  };

  // دالة تحقق ما إذا كانت المجموعة تطابق فلتر الحالة
  const statusMatches = (g, filter) => {
    if (!filter || filter === "all") return true;
    const st = g.entries?.[0]?.tenant?.status;
    if (st === undefined || st === null) return false;
    if (filter === "active") return String(st) === "1" || st === 1;
    if (filter === "inactive") return String(st) === "0" || st === 0;
    return true;
  };

  // دالة تحقق تطابق فلتر الموظف
  const employeeMatches = (g, filter) => {
    if (!filter || filter === "all") return true;
    const low = filter.toLowerCase();
    // افحص اسم الموظف من أول سجل ثم كل الإدخالات
    const firstName = (g.entries?.[0]?.employee_name || g.entries?.[0]?.employee || "").toString().toLowerCase();
    if (firstName.includes(low)) return true;
    return (g.entries || []).some((e) => ((e.employee_name || e.employee) || "").toString().toLowerCase().includes(low));
  };

  // دالة تحقق تطابق فلتر الباقة
  const planMatches = (g, filter) => {
    if (!filter || filter === "all") return true;
    const low = filter.toLowerCase();
    // افحص اسم الباقة على مستوى المجموعة ثم كل الإدخالات
    if ((g.plan_name || "").toString().toLowerCase().includes(low)) return true;
    return (g.entries || []).some((e) => ((e.plan_name || "").toString().toLowerCase().includes(low)));
  };

  // دالة تحقق تطابق نطاق التاريخ مع مجموعة التجديد
  const dateRangeMatches = (g, from, to) => {
    // إذا لم يوجد فلتر تاريخي فاعتبرها مطابقة
    if (!from && !to) return true;
    // استخرج تاريخ البداية والنهاية للمجموعة (من tenant أو من أول سجل)
    const start = g.tenant?.start_date ?? g.entries?.[0]?.tenant?.start_date ?? g.entries?.[0]?.start_date ?? null;
    const end = g.tenant?.end_date ?? g.entries?.[0]?.tenant?.end_date ?? g.entries?.[0]?.end_date ?? null;
    if (!start && !end) return false;
    // تحويل للنطاق الزمني بدون الوقت
    const toDate = (s) => {
      try { return new Date(s + "T00:00:00"); } catch { return null; }
    };
    const sDate = toDate(start);
    const eDate = toDate(end);
    const fDate = from ? toDate(from) : null;
    const tDate = to ? toDate(to) : null;
    // شروط الانطباق:
    // إذا حُدد from فقط: نريد المجموعات التي end >= from OR start >= from (أي تقع ضمن/بعد البداية)
    if (fDate && !tDate) {
      if (eDate && eDate >= fDate) return true;
      if (sDate && sDate >= fDate) return true;
      return false;
    }
    // إذا حُدد to فقط: نريد المجموعات التي start <= to OR end <= to (أي تقع ضمن/قبل النهاية)
    if (tDate && !fDate) {
      if (sDate && sDate <= tDate) return true;
      if (eDate && eDate <= tDate) return true;
      return false;
    }
    // إذا حُدد كلاهما: نقبل المجموعات التي تتقاطع فتراتُها مع الفترة [from, to]
    if (fDate && tDate) {
      // لو لا يوجد تواريخ داخل المجموعة لا تطابق
      if (!sDate && !eDate) return false;
      // إذا كان لدى المجموعة فقط تاريخ بداية، اعتبر الفترة [start, start]
      const gStart = sDate || eDate;
      const gEnd = eDate || sDate;
      // التحقق من تداخل الفترتين
      return !(gEnd < fDate || gStart > tDate);
    }
    return true;
  };

  // دالة تحقق تطابق نطاق تاريخ التجديد لأي سجل في المجموعة
  const renewDateRangeMatches = (g, from, to) => {
    if (!from && !to) return true;
    const toDate = (s) => {
      try { return new Date(s + "T00:00:00"); } catch { return null; }
    };
    const fDate = from ? toDate(from) : null;
    const tDate = to ? toDate(to) : null;
    // ابحث في الإدخالات عن أي renew_date أو created_at يطابق النطاق
    const entries = g.entries || [];
    const dates = entries.map((e) => e.renew_date || e.created_at).filter(Boolean);
    if (dates.length === 0) return false;
    // تحويل وتحقق
    for (const ds of dates) {
      const d = toDate(ds);
      if (!d) continue;
      if (fDate && !tDate) {
        if (d >= fDate) return true;
      } else if (tDate && !fDate) {
        if (d <= tDate) return true;
      } else if (fDate && tDate) {
        if (!(d < fDate || d > tDate)) return true;
      }
    }
    return false;
  };

  // القائمة بعد تطبيق الفلترة
  const filteredGroupedRenews = groupedRenews.filter((g) => {
    return groupMatchesSearch(g, debouncedSearch)
      && statusMatches(g, statusFilter)
      && employeeMatches(g, employeeFilter)
      && planMatches(g, planFilter)
      && dateRangeMatches(g, dateFrom, dateTo)
      && renewDateRangeMatches(g, renewDateFrom, renewDateTo);
  });

  // إضافة دوال التصدير قبل return (ضمن نفس الملف)
  const escapeCsv = (val) => {
    if (val === null || val === undefined) return "";
    const s = String(val);
    // إذا يحتوي على فاصلة أو اقتباس أو سطر جديد، ضع بين اقتباسات مزدوجة واهرب الاقتباسات المزدوجة
    if (/[,"\n\r]/.test(s)) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };

  const buildCsvContent = (groups) => {
    // رأس الأعمدة (محدثة بتسميات عربية أوضح)
    const headers = [
      "معرف المستأجر",
      "اسم المستخدم",
      "البريد الإلكتروني للمستخدم",
      "هاتف المستخدم",
      "اسم الوسيط",
      "اسم الباقة",
      "السعر الشهري",
      "تاريخ بدء الاشتراك",
      "تاريخ انتهاء الاشتراك",
      "حالة الاشتراك",
      "عدد التجديدات",
      "إجمالي التكلفة",
      "تاريخ آخر تجديد",
      "آخر مسؤول/موظف",
      "ملاحظات"
    ];
    const rows = [headers.map(escapeCsv).join(",")];

    groups.forEach((g) => {
      const first = g.entries?.[0] || {};
      const broker = first.user?.broker;
      const brokerText = broker ? (typeof broker === "string" ? broker : broker.name ?? "") : "";
      const row = [
        g.tenant_id ?? "",
        first.user?.name ?? "",
        first.user?.email ?? "",
        first.user?.phone ?? "",
        brokerText,
        g.plan_name ?? "",
        g.plan_monthly != null ? g.plan_monthly : "",
        // استخدام tenant أو أول سجل
        (g.tenant?.start_date ?? first.tenant?.start_date ?? first.start_date) ?? "",
        (g.tenant?.end_date ?? first.tenant?.end_date ?? first.end_date) ?? "",
        tenantStatusText(first.tenant?.status) ?? "",
        g.count ?? 0,
        Number.isFinite(g.total_cost) ? g.total_cost.toFixed(2) : (g.total_cost ?? ""),
        g.last_renew_date ?? (g.latestEntry?.renew_date ?? g.latestEntry?.created_at) ?? "",
        g.latestEntry?.employee_name ?? first.employee_name ?? "",
        // جمع ملاحظات من أول سجل (يمكن تعديل لتجميع كل الملاحظات)
        (first.notes ?? "") ?? ""
      ];
      rows.push(row.map(escapeCsv).join(","));
    });

    return rows.join("\n");
  };

  const downloadCsv = (content, filename = "subscriptions_export.csv") => {
    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  // زر الاستدعاء: يستخدم filteredGroupedRenews
  const handleExport = () => {
    try {
      const csv = buildCsvContent(filteredGroupedRenews);
      // اسم الملف يعكس التاريخ الحالي
      const now = new Date();
      const name = `subscriptions_export_${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}.csv`;
      downloadCsv(csv, name);
    } catch (err) {
      console.error("Export CSV error:", err);
      // يمكن إضافة إشعار للمستخدم هنا
    }
  };

  return (
    <Box dir="rtl" sx={{ p: 3, minHeight: "100vh", background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)" }}>
      {/* Tabs header */}
      <Paper elevation={3} sx={{ mb: 3, borderRadius: 2, overflow: "hidden" }}>
        <Tabs 
          value={tabIndex} 
          onChange={handleTabChange} 
          sx={{ 
            borderBottom: 1, 
            borderColor: "divider",
            "& .MuiTab-root": { 
              fontSize: "1rem", 
              fontWeight: 600,
              textTransform: "none",
              minHeight: 56
            }
          }}
        >
          <Tab label="قائمة الاشتراكات" />
          <Tab label="تقارير التجديدات" />
        </Tabs>
      </Paper>

      {/* Tab panels */}
      {tabIndex === 0 && (
        <>
          <Typography variant="h4" sx={{ mb: 3, fontWeight: 800, color: "#2c3e50", textAlign: "center" }}>
            جميع سجلات التجديد
          </Typography>

          {/* حقل البحث */}
          <Paper elevation={4} sx={{ p: 2.5, mb: 3, borderRadius: 3, background: "#fff" }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 700, color: "#34495e" }}>
              🔍 البحث والفلترة
            </Typography>
            {/* صف أول: البحث والحالة والموظف */}
            <Box sx={{ mb: 2, display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
              <TextField
                size="small"
                sx={{ flex: "1 1 300px" }}
                placeholder="ابحث بمعرف المستأجر، المستخدم، الباقة، الملاحظات، الموظف، إلخ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                  endAdornment: searchTerm ? (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => setSearchTerm("")}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
              />

              <FormControl size="small" sx={{ minWidth: 160 }}>
                <InputLabel id="status-filter-label">حالة النسخة</InputLabel>
                <Select
                  labelId="status-filter-label"
                  value={statusFilter}
                  label="حالة النسخة"
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <MenuItem value="all">الكل</MenuItem>
                  <MenuItem value="active">نشط</MenuItem>
                  <MenuItem value="inactive">غير نشط</MenuItem>
                </Select>
              </FormControl>

              {/* فلتر الموظف */}
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel id="employee-filter-label">الموظف</InputLabel>
                <Select
                  labelId="employee-filter-label"
                  value={employeeFilter}
                  label="الموظف"
                  onChange={(e) => setEmployeeFilter(e.target.value)}
                >
                  <MenuItem value="all">الكل</MenuItem>
                  {employeesList.map((n) => (
                    <MenuItem key={n} value={n}>{n}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* فلتر الباقة */}
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel id="plan-filter-label">الباقة</InputLabel>
                <Select
                  labelId="plan-filter-label"
                  value={planFilter}
                  label="الباقة"
                  onChange={(e) => setPlanFilter(e.target.value)}
                >
                  <MenuItem value="all">الكل</MenuItem>
                  {plansList.map((p) => (
                    <MenuItem key={p} value={p}>{p}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {/* صف ثاني: فلاتر التواريخ */}
            <Box sx={{ mb: 2, display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
              {/* فلتر نطاق التاريخ */}
              <Box sx={{ display: "flex", gap: 1, alignItems: "center", border: "1px solid #e0e0e0", borderRadius: 2, p: 1.5, background: "#fafafa" }}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: "#555", mr: 1 }}>مدة الاشتراك:</Typography>
                <TextField
                  label="من"
                  type="date"
                  size="small"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                />
                <TextField
                  label="إلى"
                  type="date"
                  size="small"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                />
                <IconButton size="small" color="error" onClick={() => { setDateFrom(""); setDateTo(""); }} title="مسح">
                  <ClearIcon fontSize="small" />
                </IconButton>
              </Box>

              {/* فلتر نطاق تاريخ التجديد */}
              <Box sx={{ display: "flex", gap: 1, alignItems: "center", border: "1px solid #e0e0e0", borderRadius: 2, p: 1.5, background: "#fafafa" }}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: "#555", mr: 1 }}>تاريخ التجديد:</Typography>
                <TextField
                  label="من"
                  type="date"
                  size="small"
                  value={renewDateFrom}
                  onChange={(e) => setRenewDateFrom(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                />
                <TextField
                  label="إلى"
                  type="date"
                  size="small"
                  value={renewDateTo}
                  onChange={(e) => setRenewDateTo(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                />
                <IconButton size="small" color="error" onClick={() => { setRenewDateFrom(""); setRenewDateTo(""); }} title="مسح">
                  <ClearIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>

            {/* صف ثالث: أزرار الإجراءات */}
            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
              <Button 
                variant="contained" 
                color="success" 
                size="medium"
                onClick={handleExport}
                sx={{ textTransform: "none", fontWeight: 600, px: 3 }}
              >
                📊 تصدير إلى Excel
              </Button>
            </Box>
          </Paper>

          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Paper elevation={2} sx={{ p: 3, background: "#ffebee", borderRadius: 2 }}>
              <Typography color="error">{error}</Typography>
            </Paper>
          ) : (
            <Paper elevation={6} sx={{ p: 2.5, borderRadius: 3, background: "#fff" }}>
              <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#2c3e50" }}>
                  📋 السجلات ({filteredGroupedRenews.length})
                </Typography>
              </Box>
              <TableContainer dir="rtl" sx={{ maxHeight: 520, borderRadius: 2, border: "1px solid #e0e0e0" }}>
                <Table stickyHeader size="small" sx={{ "& .MuiTableCell-head": { background: "#34495e", color: "#fff", fontWeight: 700 } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="right">المستخدم</TableCell>
                      <TableCell align="right">معرف المستأجر</TableCell>
                      <TableCell align="right">الوسيط</TableCell>
                      <TableCell align="right">الباقة</TableCell>
                      <TableCell align="right">المدة</TableCell>
                      <TableCell align="right">حالة النسخة</TableCell>
                      <TableCell align="right">تاريخ الإنشاء</TableCell>
                      <TableCell align="right">التكلفة</TableCell>
                      <TableCell align="right">تاريخ التجديد</TableCell>
                      <TableCell align="right">الموظف</TableCell>
                      <TableCell align="right">ملاحظات</TableCell>
                      <TableCell align="right">عدد التجديدات</TableCell>
                      <TableCell align="right">الأيام المتبقية</TableCell>
                      <TableCell align="right">آخر تجديد</TableCell>
                      <TableCell align="right">إجراءات </TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ "& .MuiTableRow-root:hover": { background: "#f5f5f5" } }}>
                    {filteredGroupedRenews.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={14} align="center">
                          لا توجد سجلات
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredGroupedRenews.map((g) => (
                        <TableRow key={g.tenant_id}>
                          {/* مستخدم (من أول سجل) */}
                          <TableCell align="right">
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.3 }}>
                              <Typography sx={{ fontWeight: 800 }}>{g.entries[0].user?.name ?? "-"}</Typography>
                              <Typography variant="body2" sx={{ color: "text.secondary", fontSize: "0.85rem" }}>
                                البريد: {g.entries[0].user?.email ?? "-"}
                              </Typography>
                              <Typography variant="body2" sx={{ color: "text.secondary", fontSize: "0.85rem" }}>
                                الجوال: {g.entries[0].user?.phone ?? "-"}
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell align="right">
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.3 }}>
                              <Typography sx={{ fontWeight: 700 }}>{g.tenant_id}</Typography>
                              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                                أنشئت: {(g.entries[0].tenant?.created_at ?? g.entries[0].tenant_created_at)}
                              </Typography>
                            </Box>
                          </TableCell>

                          {/* الوسيط */}
                          <TableCell align="right">
                            {g.entries[0].user?.broker ? (
                              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.25 }}>
                                <Typography sx={{ fontWeight: 700 }}>{g.entries[0].user.broker.name ?? g.entries[0].user.broker}</Typography>
                                {g.entries[0].user.broker.email && (
                                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                                    {g.entries[0].user.broker.email}
                                  </Typography>
                                )}
                                {g.entries[0].user.broker.code && (
                                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                                    كود الوسيط: {g.entries[0].user.broker.code}
                                  </Typography>
                                )}
                              </Box>
                            ) : (
                              <Typography variant="body2" sx={{ color: "text.secondary" }}>-</Typography>
                            )}
                          </TableCell>

                          {/* الباقة */}
                          <TableCell align="right">
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                              <Typography sx={{ fontWeight: 700 }}>{g.plan_name}</Typography>
                              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                                {g.entries[0].plan_monthly != null ? `شهري: ${g.entries[0].plan_monthly} ج` : ""}
                              </Typography>
                            </Box>
                          </TableCell>

                          {/* المدة: start_date - end_date من tenant */}
                          <TableCell align="right">
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                من: {(g.entries[0].tenant?.start_date ?? g.entries[0].start_date ?? g.entries[0].tenant?.start_date)}
                              </Typography>
                              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                إلى: {(g.entries[0].tenant?.end_date ?? g.entries[0].end_date ?? g.entries[0].tenant?.end_date)}
                              </Typography>
                            </Box>
                          </TableCell>

                          {/* حالة النسخة */}
                          <TableCell align="right">
                            <Chip
                              label={tenantStatusText(g.entries[0].tenant?.status)}
                              color={tenantStatusColor(g.entries[0].tenant?.status)}
                              size="small"
                            />
                          </TableCell>

                          {/* تاريخ الإنشاء الفعلي */}
                          <TableCell align="right">{formatDate(g.entries[0].created_at)}</TableCell>
                          <TableCell align="right">{g.entries[0].cost ? `${g.entries[0].cost} ج` : "-"}</TableCell>
                          <TableCell align="right">{g.entries[0].renew_date || g.entries[0].created_at}</TableCell>
                          <TableCell align="right">{g.entries[0].employee_name ?? "-"}</TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              maxWidth: 220,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            title={g.entries[0].notes ?? ""}
                          >
                            {g.entries[0].notes ?? "-"}
                          </TableCell>

                          {/* عدد التجديدات */}
                          <TableCell align="right">{g.count}</TableCell>

                          {/* الأيام المتبقية (باستخدام end_date من tenant أو من أول سجل) */}
                          <TableCell align="right">
                            {renderDaysChip(daysRemaining(g.tenant?.end_date ?? g.entries[0]?.tenant?.end_date ?? null))}
                          </TableCell>

                          {/* آخر تجديد */}
                          <TableCell align="right">{formatDate(g.last_renew_date)}</TableCell>

                          {/* عدد التجديدات ، آخر موظف ، زر عرض التفاصيل - يفتح مودال لتفاصيل entries */}
                          <TableCell align="right">
                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                              <Button size="small" onClick={() => setSelectedGroup(g)}>عرض التجديدات</Button>
                              <Button size="small" variant="contained" color="primary" onClick={() => handleOpenRenew(g)}>
                                تجديد
                              </Button>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )}

          {/* Renew dialog */}
          <RenewSystemDialog
            open={openRenewDialog}
            onClose={() => setOpenRenewDialog(false)}
            tenantId={renewDefaults?.tenant_id}
            defaults={{
              cost: renewDefaults?.cost,
              start_date: renewDefaults?.start_date,
              end_date: renewDefaults?.end_date,
            }}
            onSuccess={handleRenewSuccess}
          />

          {/* Dialog: تفاصيل مجموعة التجديدات */}
          <Dialog open={Boolean(selectedGroup)} onClose={() => setSelectedGroup(null)} fullWidth maxWidth="md">
            <DialogTitle>
              تفاصيل تجديدات المستأجر: {selectedGroup?.tenant_id}
              <IconButton onClick={() => setSelectedGroup(null)} sx={{ ml: 2 }}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent dividers dir="rtl">
              {selectedGroup && (
                <TableContainer dir="rtl">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="right">#</TableCell>
                        <TableCell align="right">الباقة</TableCell>
                        <TableCell align="right">بداية الباقة</TableCell>
                        <TableCell align="right">نهاية الباقة</TableCell>
                        <TableCell align="right">تاريخ الإنشاء</TableCell>
                        <TableCell align="right">التكلفة</TableCell>
                        <TableCell align="right">الموظف</TableCell>
                        <TableCell align="right">ملاحظات</TableCell>
                        <TableCell align="right">الأيام المتبقية</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedGroup.entries.map((e) => (
                        <TableRow key={e.id}>
                          <TableCell align="right">{e.id}</TableCell>
                          <TableCell align="right">{e.plan_name ?? "-"}</TableCell>
                          <TableCell align="right">{formatDate(e.tenant?.start_date ?? e.start_date)}</TableCell>
                          <TableCell align="right">{formatDate(e.tenant?.end_date ?? e.end_date)}</TableCell>
                          <TableCell align="right">{formatDate(e.created_at)}</TableCell>
                          <TableCell align="right">{e.cost ? `${e.cost} ج` : "-"}</TableCell>
                          <TableCell align="right">{e.employee_name ?? "-"}</TableCell>
                          <TableCell align="right" title={e.notes ?? ""} sx={{ maxWidth: 300, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {e.notes ?? "-"}
                          </TableCell>
                          <TableCell align="right">{renderDaysChip(daysRemaining(e.tenant?.end_date ?? e.end_date))}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </DialogContent>
          </Dialog>
        </>
      )}

      {tabIndex === 1 && (
        <Box sx={{ mt: 1 }}>
          <AllSubscriptionsReportsTap />
        </Box>
        )}  
    </Box>
  );
};

export default AllSubscriptionsPage;
